"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "#2F8AF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.376 10.824c.15-.496 0-.86-.706-.86h-2.338c-.595 0-.867.315-1.017.66 0 0-1.189 2.9-2.874 4.78-.543.547-.792.72-1.088.72-.149 0-.364-.173-.364-.668v-4.632c0-.595-.172-.86-.668-.86h-3.675c-.37 0-.595.276-.595.538 0 .563.843.693.93 2.28v3.442c0 .754-.136.892-.435.892-.792 0-2.72-2.91-3.864-6.242-.223-.647-.448-.908-1.045-.908H6.299c-.669 0-.802.314-.802.66 0 .62.792 3.692 3.69 7.754 1.933 2.773 4.654 4.277 7.132 4.277 1.486 0 1.669-.334 1.669-.91v-2.096c0-.668.142-.802.612-.802.345 0 .94.175 2.328 1.51 1.585 1.586 1.847 2.297 2.737 2.297h2.338c.668 0 1.001-.334.81-.993-.21-.656-.968-1.61-1.972-2.74-.546-.644-1.362-1.337-1.61-1.683-.347-.447-.247-.644 0-1.041 0 0 2.849-4.01 3.145-5.375Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgVk);
var _default = exports["default"] = Memo;